import { Box, Button, Circle, FormControl, FormErrorMessage, FormLabel, Input, Text, Textarea, useToast, Radio, RadioGroup, Stack } from "@chakra-ui/react";
// import { Field, Form, Formik } from "formik";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetEdit, setHeaderText } from "../../redux/actions/actions";
import { useHistory } from "react-router-dom";
import { submitAnnouncementForm, updateAnnouncementForm } from "../../redux/api_calls/apiCalls";
import { ReactComponent as AddPhoto } from "../../svg/AddPhoto.svg";

export default function AddAnnouncements() {
    const [announcementNameError, setAnnouncementNameError] = useState(null)
    const [announcementDescriptionError, setAnnouncementDescriptionError] = useState(null)
    const [announcementImage, setAnnouncementImage] = useState(null)
    const [announcementImageError, setAnnouncementImageError] = useState(null)
    const [announcementImageUrl, setAnnouncementImageUrl] = useState(null)
    const [departmentNameError, setDepartmentNameError] = useState(null)
    const [startDateError, setStartDateError] = useState(null);
    const [startTimeError, setStartTimeError] = useState(null);
    const [endDateError, setEndDateError] = useState(null);
    const [endTimeError, setEndTimeError] = useState(null);
    const [radioButtonValue, setRadioButtonValue] = useState('now')
    const dispatch = useDispatch()
    const history = useHistory()
    const toast = useToast()
    const formStatus = useSelector(state => state.formStatus)
    const editState = useSelector(state => state.editState)
    const { announcementsData } = useSelector(state => state.announcementsState)
    const headerText = useSelector(state => state.headerState.headerText)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const departmentNameRef = useRef()
    const startDateRef = useRef();
    const startTimeRef = useRef();
    const endDateRef = useRef();
    const endTimeRef = useRef();
    const announcementNameRef = useRef()
    const descriptionRef = useRef()

    function validatePhoto() {
        if (!announcementImage) {
            setAnnouncementImageError("Please select a Cover Photo for the Announcement!");
            return true;
        } else {
            setAnnouncementImageError(null);
            return false;
        }
    }

    function validateDepartmentName() {
        let departmentName = departmentNameRef.current.value.trim();
        if (!departmentName.length) {
            setDepartmentNameError("Department Name is required");
            return true;
        } else {
            setDepartmentNameError(null);
            return false;
        }
    }

    function validateAnnouncementName() {
        let annoucementTitle = announcementNameRef.current.value;
        if (!annoucementTitle.length) {
            setAnnouncementNameError("Announcement Title is required")
            return true
        }
        else {
            setAnnouncementNameError(null);
            return false
        }
    }

    function validateDescription() {
        let announcementDescription = descriptionRef.current.value;
        if (!announcementDescription.length) {
            setAnnouncementDescriptionError("Description is required")
            return true
        }
        else {
            setAnnouncementDescriptionError(null);
            return false
        }
    }

    function validateStartDate() {
        if (radioButtonValue === 'later') {
            let error;
            let date = new Date(Date.now())
            let today = date.getFullYear() + '-' + (Number(date.getMonth()) + 1) + '-' + date.getDate()
            let startDate = startDateRef.current.value.trim();
            if (!startDate.length) {
                error = "Announcement Start Date is required";
            } else if (Date.parse(startDate) < Date.parse(today)) {
                error = "Announcement Start Date cannot be less than today!";
            }
            if (error) {
                setStartDateError(error);
                return true;
            } else {
                setStartDateError(null);
                return false;
            }
        }
        else {
            return false
        }
    }

    function validateStartTime() {
        if (radioButtonValue === 'later') {
            let time = startTimeRef.current.value.trim()
            let selectedTime = time.split(":")
            let date = new Date(Date.now())
            let year = date.getFullYear()
            let month = (Number(date.getMonth()) + 1)
            let day = date.getDate()
            let today = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
            let startDate = startDateRef.current.value.trim();
            let currentHour = new Date().getHours()
            let currentMinutes = new Date().getMinutes()
            if (!time.length) {
                setStartTimeError("Start Time is required!")
                return true
            }
            else if ((startDate === today && Number(selectedTime[0]) < Number(currentHour)) || (startDate === today && Number(selectedTime[0]) === Number(currentHour) && Number(selectedTime[1]) < Number(currentMinutes))) {
                setStartTimeError("Start Time cannot be less than current time!")
                return true
            }
            else if (startDate === today && selectedTime[0] === currentHour && selectedTime[1] === currentMinutes) {
                setStartTimeError("Start Time cannot be equal to current time!")
                return true
            }
            else {
                setStartTimeError(null)
                return false
            }
        }
        else {
            return false
        }
    }

    function validateEndDate() {
        let error;
        let date = new Date(Date.now())
        let today = date.getFullYear() + '-' + (Number(date.getMonth()) + 1) + '-' + date.getDate()
        let startDate = radioButtonValue === 'later' ? startDateRef.current.value.trim() : '';
        let endDate = endDateRef.current.value.trim();
        if (!endDate.length) {
            error = "Announcement End Date is required";
        } else if (Date.parse(endDate) < Date.parse(today)) {
            error = "Announcement End Date cannot be less than today!";
        } else if (startDate.length) {
            if (Date.parse(startDate) > Date.parse(endDate)) {
                error = "Announcement End Date cannot be earlier than Announcement Start Date!";
            }
        }
        if (error) {
            setEndDateError(error);
            return true;
        } else {
            setEndDateError(null);
            return false;
        }
    }

    function validateEndTime() {
        let time = endTimeRef.current.value.trim()
        let startTime = radioButtonValue === 'later' ? startTimeRef.current.value.trim() : ''
        let selectedTime = time.split(":")
        let date = new Date(Date.now())
        let year = date.getFullYear()
        let month = (Number(date.getMonth()) + 1)
        let day = date.getDate()
        let today = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
        let endDate = endDateRef.current.value.trim();
        let currentHour = new Date().getHours()
        let currentMinutes = new Date().getMinutes()
        if (!time.length) {
            setEndTimeError("End Time is required!")
            return true
        }
        else if ((endDate === today && Number(selectedTime[0]) < Number(currentHour)) || (endDate === today && Number(selectedTime[0]) === Number(currentHour) && Number(selectedTime[1]) < Number(currentMinutes))) {
            setEndTimeError("End Time cannot be less than current time!")
            return true
        }
        else if (endDate === today && selectedTime[0] === currentHour && selectedTime[1] === currentMinutes) {
            setEndTimeError("End Time cannot be equal to current time!")
            return true
        }
        else if (startTime === time) {
            setEndTimeError("End Time cannot be the same as Start Time!")
            return true
        }
        else {
            setEndTimeError(null)
            return false
        }
    }

    const validateFields = () => {
        return validatePhoto() ||
            validateDepartmentName() ||
            validateAnnouncementName() ||
            validateDescription() ||
            validateStartDate() ||
            validateStartTime() ||
            validateEndDate() ||
            validateEndTime();
    }

    const cancelHandler = () => {
        dispatch(resetEdit())
        history.push('/announcements')
    }


    const formatTime = (time) => {
        let timeArray = time.split(":")
        let amPm = Number(timeArray[0]) > 12 ? 'PM' : 'AM'
        if (Number(timeArray[0])) {
            timeArray[0] = Number(timeArray[0]) - 12
        }
        return timeArray.join(":") + " " + amPm
    }

    const getTodaysDate = () => {
        let date = new Date(Date.now())
        let year = date.getFullYear()
        let month = (Number(date.getMonth()) + 1)
        let day = date.getDate()
        let today = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
        return today
    }

    const getCurrentTime = () => {
        let currentHour = new Date().getHours()
        let currentMinutes = new Date().getMinutes()
        return (currentHour < 10 ? '0' + currentHour : currentHour) + ':' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes)
    }


    const appendData = (formData) => {
        formData.append("title", announcementNameRef.current.value.trim())
        formData.append("description", descriptionRef.current.value.trim())
        formData.append("start_date", radioButtonValue === 'later' ? startDateRef.current.value : getTodaysDate())
        formData.append("end_date", endDateRef.current.value)
        formData.append("image", announcementImage)
        formData.append("status", "Y")
        formData.append("start_time", formatTime(radioButtonValue === 'later' ? startTimeRef.current.value : getCurrentTime()))
        formData.append("end_time", formatTime(endTimeRef.current.value))
        formData.append("department", departmentNameRef.current.value)
    }

    const addNewAnnouncement = () => {
        let formData = new FormData()
        appendData(formData)
        dispatch(submitAnnouncementForm(formData));
    }

    const updateAnnouncement = () => {
        let formData = new FormData()
        appendData(formData)
        dispatch(updateAnnouncementForm(formData, editState.id))
    }

    const submitHandler = () => {
        if (validateFields()) {
            return
        }
        else {
            if (editState.flag) {
                updateAnnouncement()
            }
            else {
                addNewAnnouncement()
            }
        }
    }
    const resetForm = () => {
        setAnnouncementImage(null);
        setAnnouncementImageUrl(null)
        setRadioButtonValue('now')
        departmentNameRef.current.value = ""
        if (radioButtonValue === 'later') {
            startDateRef.current.value = "";
            startTimeRef.current.value = "";
        }
        endDateRef.current.value = "";
        endTimeRef.current.value = "";
        announcementNameRef.current.value = ""
        descriptionRef.current.value = ""
    }

    const formatDatabaseTimeParameter = (time) => {
        let timeArray = time.split(" ")[0].split(":")
        if (time.includes("PM")) {
            timeArray[0] = Number(timeArray[0]) + 12
        }
        return timeArray.join(":")
    }

    const preFillForm = () => {
        setRadioButtonValue('later')
    }

    useEffect(() => {
        if (editState.flag && radioButtonValue === 'later') {
            let currentAnnouncement = announcementsData.find(announcement => announcement.id === editState.id)
            announcementNameRef.current.value = currentAnnouncement.title
            departmentNameRef.current.value = currentAnnouncement.department ? currentAnnouncement.department : ''
            descriptionRef.current.value = currentAnnouncement.description
            setAnnouncementImage(currentAnnouncement.image_url ? currentAnnouncement.image_url.replaceAll(" ", "%20") : null)
            setAnnouncementImageUrl(currentAnnouncement.image_url ? currentAnnouncement.image_url.replaceAll(" ", "%20") : null)
            startDateRef.current.value = currentAnnouncement.start_date
            endDateRef.current.value = currentAnnouncement.end_date
            startTimeRef.current.value = currentAnnouncement.start_time ? formatDatabaseTimeParameter(currentAnnouncement.start_time) : ''
            endTimeRef.current.value = currentAnnouncement.end_time ? formatDatabaseTimeParameter(currentAnnouncement.end_time) : ''
        }
        // eslint-disable-next-line
    }, [radioButtonValue, editState.flag])

    useEffect(() => {
        if (editState.flag) {
            dispatch(setHeaderText('Edit Announcement'))
            preFillForm()
        }
        else {
            dispatch(setHeaderText('Add Announcement'))
        }
        // eslint-disable-next-line
    }, [dispatch, editState])

    useEffect(() => {
        if (formStatus.success && !formStatus.error) {
            if (editState.flag) {
                dispatch(resetEdit())
                toast({
                    title: "Announcement Edited Successfully!",
                    description: "Announcement Edited!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
                history.push('/announcements')
            }
            else {
                toast({
                    title: "Announcement Added Successfully!",
                    description: "Announcement Added!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
            }
            resetForm()
            history.push('/announcements')
        }
        else if (formStatus.error) {
            toast({
                title: "Something went wrong!",
                description: "Error!",
                status: "error",
                duration: 3000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.success, formStatus.error])

    useEffect(() => {
        if (announcementImage) {
            if (typeof announcementImage === "object") {
                let extension = announcementImage.name.substring(
                    announcementImage.name.lastIndexOf(".") + 1
                );
                let acceptedExtensions = ["jpeg", "jpg", "png"];
                if (!acceptedExtensions.includes(extension.toLowerCase())) {
                    setAnnouncementImageError("Invalid file type");
                    setAnnouncementImageUrl(null)
                    setAnnouncementImage(null);
                }
                else if ((announcementImage.size / (1024 * 1024)) > 0.5) {
                    setAnnouncementImageError("Please upload files of size less than or equal to 512 kb!");
                    setAnnouncementImageUrl(null)
                    setAnnouncementImage(null);
                }
                else {
                    setAnnouncementImageUrl(URL.createObjectURL(announcementImage))
                }
            }
        }
    }, [announcementImage]);

    return (
        <Box
            flexGrow='1'
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box width={['95%', '95%', '90%', '85%']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} alignItems={['center', 'center', 'flex-start', 'flex-start']} d='flex' mb='2rem' flexDirection='column'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }} mb='2rem'>{headerText}</Text>
                <Box width={['100%', '100%', '100%', '85%']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} alignItems={['center', 'center', 'flex-start', 'flex-start']} d='flex'>

                    <Box style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '90%' }}>

                        <FormControl isInvalid={announcementImageError}>
                            <FormLabel
                                variant="custom"
                                htmlFor="add_photo"
                                style={{ fontFamily: "Mulish, sans-serif" }}
                            >
                                Cover Image
                            </FormLabel>

                            <Box width="140px" id="add_photo" mr='5rem' position='relative'>
                                <label htmlFor="add_photo_helper">
                                    <Button
                                        as="span"
                                        width="140px"
                                        height="140px"
                                        bg="white"
                                        bgImage={announcementImageUrl ? announcementImageUrl : null}
                                        bgRepeat='no-repeat'
                                        bgSize='cover'
                                        bgPosition='center'
                                        borderRadius="xl"
                                        fontWeight="800"
                                        fontSize={["12px", "14px", "16px", "18px"]}
                                        style={{ fontFamily: "Mulish, sans-serif" }}
                                        color="#E4B716"
                                        _hover={{ bg: "white", bgImage: announcementImageUrl ? announcementImageUrl : null, bgRepeat: 'no-repeat', bgSize: 'cover', bgPosition: 'center' }}
                                        d="flex"
                                        flexDir="column"
                                        border="1px solid rgba(0, 0, 0, 0.1)"
                                        cursor="pointer"
                                    >
                                        {
                                            !announcementImageUrl &&
                                            <>
                                                <AddPhoto style={{ marginBottom: "0.5rem" }} />
                                                Add Photo
                                            </>
                                        }
                                    </Button>
                                    {
                                        announcementImageUrl &&
                                        <Circle
                                            size='30px'
                                            bg='white'
                                            position='absolute'
                                            right='-15px'
                                            bottom='10px'
                                            boxShadow='xl'
                                            border="1px solid rgba(0, 0, 0, 0.1)"
                                            cursor='pointer'
                                        >
                                            <AddPhoto width='15px' height='15px' />
                                        </Circle>
                                    }
                                </label>
                                <input
                                    accept="image/png, image/jpeg, image/jpg"
                                    id="add_photo_helper"
                                    name="add_photo_helper"
                                    type="file"
                                    onChange={(e) => {
                                        setAnnouncementImage(e.target.files[0]);
                                        setAnnouncementImageError(null);
                                    }}
                                    style={{ display: "none" }}
                                />
                            </Box>
                            <FormErrorMessage fontSize="sm">
                                {announcementImageError}
                            </FormErrorMessage>
                            {announcementImage && (
                                <Text
                                    mt="1"
                                    fontWeight="600"
                                    color="#666666"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                    fontSize="md"
                                >
                                    Attached file :
                                    <span style={{ fontSize: "13px", marginLeft: '1em' }}>
                                        <em>{announcementImage.name ? `${announcementImage.name} - ${(announcementImage.size / (1024 * 1024)).toFixed(2)} MB` : announcementImage}</em>
                                    </span>
                                </Text>
                            )}
                        </FormControl>

                        <FormControl isInvalid={departmentNameError}>
                            <FormLabel
                                variant="custom"
                                htmlFor="department_name"
                                style={{ fontFamily: "Mulish, sans-serif" }}
                            >
                                Department Name
                            </FormLabel>
                            <Input
                                id="department_name"
                                width={["100%", "100%", "90%", "85%"]}
                                bgColor="white"
                                ref={departmentNameRef}
                                border='1px solid rgba(0, 0, 0, 0.1)'
                                borderRadius="13px"
                                height='40px'
                                onChange={() => {
                                    if (departmentNameRef.current.value.trim().length > 0) {
                                        setDepartmentNameError(null);
                                    }
                                }}
                            />
                            <FormErrorMessage fontSize="sm">
                                {departmentNameError}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={announcementNameError}>
                            <FormLabel variant='custom' htmlFor="announcement_name" style={{ fontFamily: 'Mulish, sans-serif' }}>Announcement Title</FormLabel>
                            <Input
                                id="announcement_name"
                                width={['100%', '100%', '90%', '85%']}
                                borderRadius='lg'
                                bgColor='white'
                                ref={announcementNameRef}
                                onChange={() => {
                                    setAnnouncementNameError(null);
                                }}
                            />
                            <FormErrorMessage fontSize='sm'>{announcementNameError}</FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={announcementDescriptionError}>
                            <FormLabel variant='custom' htmlFor="announcement_description" style={{ fontFamily: 'Mulish, sans-serif' }}>Announcement Description</FormLabel>
                            <Textarea
                                id="announcement_description"
                                width={['100%', '100%', '90%', '85%']}
                                borderRadius='lg'
                                bgColor='white'
                                rows='6'
                                resize='vertical'
                                ref={descriptionRef}
                                onChange={(e) => {
                                    // if (e.target.value.length > 0) {
                                    setAnnouncementDescriptionError(null);
                                    // }
                                }}
                            />
                            <FormErrorMessage fontSize='sm'>{announcementDescriptionError}</FormErrorMessage>
                        </FormControl>


                        <FormControl>
                            <RadioGroup style={{ fontFamily: 'Mulish, sans-serif' }} color="#666666" fontWeight='600' fontSize='16px' onChange={setRadioButtonValue} value={radioButtonValue}>
                                <Stack direction="row" spacing={8}>
                                    <Radio value="now" >Schedule Now</Radio>
                                    <Radio value="later" >Schedule For Later</Radio>
                                </Stack>
                            </RadioGroup>
                        </FormControl>

                        {
                            radioButtonValue === 'later' &&
                            <Box
                                width={["100%", "100%", "90%", "85%"]}
                                d="flex"
                                justifyContent="space-between"
                            >
                                <Box width="45%">
                                    <FormControl isInvalid={startDateError}>
                                        <FormLabel
                                            variant="custom"
                                            htmlFor="start_date"
                                            style={{ fontFamily: "Mulish, sans-serif" }}
                                        >
                                            Start Date
                                        </FormLabel>
                                        <Input
                                            type="date"
                                            color="#666666"
                                            id="start_date"
                                            width="100%"
                                            border='1px solid rgba(0, 0, 0, 0.1)'
                                            borderRadius="13px"
                                            height='40px'
                                            bgColor="white"
                                            ref={startDateRef}
                                            onChange={() => {
                                                if (startDateRef.current.value.trim().length > 0) {
                                                    setStartDateError(null);
                                                }
                                            }}
                                            fontSize={["9px", "11px", "13px", "16px"]}
                                        />
                                        <FormErrorMessage fontSize="sm">
                                            {startDateError}
                                        </FormErrorMessage>
                                    </FormControl>
                                </Box>
                                <Box width="45%">
                                    <FormControl isInvalid={startTimeError}>
                                        <FormLabel
                                            variant="custom"
                                            htmlFor="end_date"
                                            style={{ fontFamily: "Mulish, sans-serif" }}
                                        >
                                            Start Time
                                        </FormLabel>
                                        <Input
                                            type="time"
                                            color="#666666"
                                            id="start_time"
                                            width="100%"
                                            border='1px solid rgba(0, 0, 0, 0.1)'
                                            borderRadius="13px"
                                            height='40px'
                                            bgColor="white"
                                            ref={startTimeRef}
                                            fontSize={["9px", "11px", "13px", "16px"]}
                                            onChange={() => {
                                                if (startTimeRef.current.value.trim().length > 0) {
                                                    setStartTimeError(null);
                                                }
                                            }}
                                        />
                                        <FormErrorMessage fontSize="sm">
                                            {startTimeError}
                                        </FormErrorMessage>
                                    </FormControl>
                                </Box>
                            </Box>
                        }

                        <Box
                            width={["100%", "100%", "90%", "85%"]}
                            d="flex"
                            justifyContent="space-between"
                        >
                            <Box width="45%">
                                <FormControl isInvalid={endDateError}>
                                    <FormLabel
                                        variant="custom"
                                        htmlFor="end_date"
                                        style={{ fontFamily: "Mulish, sans-serif" }}
                                    >
                                        End Date
                                    </FormLabel>
                                    <Input
                                        type="date"
                                        color="#666666"
                                        id="end_date"
                                        width="100%"
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        bgColor="white"
                                        ref={endDateRef}
                                        onChange={() => {
                                            if (endDateRef.current.value.trim().length > 0) {
                                                setEndDateError(null);
                                            }
                                        }}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                    />
                                    <FormErrorMessage fontSize="sm">
                                        {endDateError}
                                    </FormErrorMessage>
                                </FormControl>
                            </Box>
                            <Box width="45%">
                                <FormControl isInvalid={endTimeError}>
                                    <FormLabel
                                        variant="custom"
                                        htmlFor="end_date"
                                        style={{ fontFamily: "Mulish, sans-serif" }}
                                    >
                                        End Time
                                    </FormLabel>
                                    <Input
                                        type="time"
                                        color="#666666"
                                        id="end_time"
                                        width="100%"
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        bgColor="white"
                                        ref={endTimeRef}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                        onChange={() => {
                                            if (endTimeRef.current.value.trim().length > 0) {
                                                setEndTimeError(null);
                                            }
                                        }}
                                    />
                                    <FormErrorMessage fontSize="sm">
                                        {endTimeError}
                                    </FormErrorMessage>
                                </FormControl>
                            </Box>
                        </Box>

                        <Box width={['100%', '100%', '90%', '85%']} d='flex' flexDir={['column', 'column', 'row', 'row']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} mt='2rem'>
                            <Button
                                bgColor='#FE5858'
                                color='white'
                                borderRadius='lg'
                                p={['6px 15px', '8px 20px', '12px 30px']}
                                _hover={{ bg: "#e44f48" }}
                                isLoading={formStatus.isSubmitting}
                                // loadingText={editState.flag ? 'Updating...' : 'Adding...'}
                                onClick={submitHandler}
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontWeight='800'
                                fontSize={['13px', '14px', '16px']}
                                mr={['0', '0', '20px', '20px']}
                                mb={['20px', '20px', '0', '0']}
                            >
                                {editState.flag ? "Update" : "Broadcast"}
                            </Button>
                            <Button
                                bgColor='white'
                                color='#999999'
                                borderRadius='lg'
                                border='1px solid rgba(0, 0, 0, 0.2)'
                                p={['6px 15px', '8px 20px', '12px 30px']}
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontWeight='800'
                                fontSize={['13px', '14px', '16px']}
                                onClick={cancelHandler}
                            >
                                Cancel
                            </Button>
                        </Box>
                        {formStatus.error &&
                            <Text
                                fontSize='sm'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                color='red.500'
                            >
                                {formStatus.error}
                            </Text>}
                    </Box>

                </Box>
            </Box>
        </Box>
    )
}